<template>
  <div>
    <div class="d-flex justify-content-center mb-1" v-if="loading">
      <b-spinner
        variant="success"
        label="Spinning"
        block
        style="width: 3rem; height: 3rem"
      ></b-spinner>
    </div>
    <b-tabs
      v-else
      v-model="tabIndex"
      vertical
      content-class="col-12 col-md-9 mt-1 mt-md-0"
      pills
      nav-wrapper-class="col-md-3 col-12"
      nav-class="nav-left"
    >
      <!-- personal information tab -->
      <b-tab active>
        <!-- title -->
        <template #title>
          <feather-icon icon="UserIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">Personal Information</span>
        </template>
        <b-card>
          <EmployeePersonalInformation
            :employeeProfile="employeeProfile"
            @updateEmployeeProfile="updateEmployeeProfile"
            ref="employeeProfileInfo"
          />

          <b-row v-if="HasPermission(permissions) && isEdit">
            <b-col cols="12">
              <b-button
                variant="primary"
                class="mt-2 mr-1"
                @click="validateProfile"
              >
                Next
              </b-button>
              <b-button
                variant="outline-secondary"
                type="reset"
                class="mt-2"
                @click.prevent="resetForm"
              >
                Cancel
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-tab>
      <!--/ personal information tab -->

      <!-- employment details tab -->
      <b-tab>
        <!-- title -->
        <template #title>
          <feather-icon icon="FileTextIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">Employment Details</span>
        </template>
        <b-card>
          <EmploymentDetails
            :employementDetail="employeeProfile"
            :managerList="managerList"
            @updateEmployement="updateEmployement"
            ref="employeeDetails"
          />
          <b-row v-if="HasPermission(permissions) && isEdit">
            <b-col cols="12">
              <b-button
                variant="primary"
                class="mt-2 mr-1"
                @click="validateDetails"
              >
                Next
              </b-button>
              <b-button
                variant="outline-secondary"
                type="reset"
                class="mt-2"
                @click.prevent="resetForm"
              >
                Cancel
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-tab>
      <!--/ employment details tab -->

      <!-- bank details tab -->
      <b-tab>
        <!-- title -->
        <template #title>
          <feather-icon icon="CreditCardIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">Bank Details</span>
        </template>

        <BankDetails
          :employeeDetail="employeeProfile"
          ref="employeeBankDetails"
        />

        <b-row v-if="HasPermission(permissions) && isEdit">
          <b-col cols="12">
            <b-button
              variant="primary"
              class="mt-2 mr-1"
              @click="validateBankDetails"
            >
              Save
            </b-button>
            <b-button
              variant="outline-secondary"
              type="reset"
              class="mt-2"
              @click.prevent="resetForm"
            >
              Cancel
            </b-button>
          </b-col>
        </b-row>
      </b-tab>

      <!-- document details tab -->
      <b-tab :title-item-class="id == undefined ? 'd-none' : ''" v-if="id != undefined">
        <!-- title -->
        <template #title>
          <feather-icon icon="FileTextIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">Document Details</span>
        </template>

        <DocumentDetails
          :employeeDetail="employeeProfile"
          @updateBank="updateBank"
        />
        <!-- <AddDocumentDetails
          :employeeDetail="employeeProfile"
          :documents="employeenewdocuments"
          v-else
          @updateBank="updateBank"
        /> -->
      </b-tab>
      <b-tab :title-item-class="id == undefined ? 'd-none' : ''" v-if="id != undefined">
        <!-- title -->
        <template #title>
          <feather-icon icon="ClipboardIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">Employee Training</span>
        </template>

        <EmployeeTraining />
      </b-tab>
      <!--/ bank details tab -->
    </b-tabs>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BFormGroup,
  BButton,
  BSpinner,
  BFormFile,
  BTabs,
  BTab,
  BCard,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { customLoader, customError, customSwal } from "@/libs/customFn";
import {
  HasPermission,
  IsAdmin,
} from "@/@core/utils/validations/permissionCheck";

import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import Swal from "sweetalert2";
import EmployeePersonalInformation from "./EmployeePersonalInformation.vue";
import EmploymentDetails from "./EmploymentDetails.vue";
import BankDetails from "./BankDetails.vue";
import DocumentDetails from "./DocumentDetails.vue";
import AddDocumentDetails from "./AddEmployeeDocumentDetails.vue";

import EmployeeTraining from "./EmployeeTraining.vue";

export default {
  name: "AddEmployee",
  components: {
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormDatepicker,
    BFormGroup,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    EmployeePersonalInformation,
    BTabs,
    BTab,
    BCard,
    EmploymentDetails,
    BankDetails,
    DocumentDetails,
    AddDocumentDetails,
    EmployeeTraining,
  },
  data() {
    return {
      id: this.$route.params.id,
      isEdit: false,
      isAdd: false,
      employeenewdocuments: [],
      employeenewtrainings: [],
      permissions: this.$route.meta.permissions,
      tabIndex: 1,
      initialEmployeeProfile: {
        firstName: null,
        lastName: null,
        dateOfBirth: null,
        gender: null,
        email: null,
        nic: null,
        phoneNumber: null,
        address: null,
        city: null,
        state: null,
        postalCode: null,
        country: null,
        designationId: null,
        departmentId: null,
        hireDate: null,
        employmentStatus: "EMPLOYED",
        salary: 0,
        managerId: null,
        notes: null,
        bankName: null,
        swiftCode: null,
        branch: null,
        accountNumber: null,
        isEdit: false,
      },
      employeeProfile: {
        firstName: null,
        lastName: null,
        dateOfBirth: null,
        gender: null,
        email: null,
        nic: null,
        phoneNumber: null,
        address: null,
        city: null,
        state: null,
        postalCode: null,
        country: null,
        designationId: null,
        departmentId: null,
        hireDate: null,
        employmentStatus: "EMPLOYED",
        salary: 0,
        managerId: null,
        notes: null,
        bankName: null,
        swiftCode: null,
        branch: null,
        accountNumber: null,
        isEdit: false,
        additionalFields: null,
      },
      managerList: [],
      required,
      tabValidations: {
        personalInfo: false,
        employmentDetails: false,
        bankDetails: false,
      },
    };
  },
  computed: {
    ...mapGetters("employeeModule", {
      employeeDetail: "employeeid",
      managerData: "employees",
      loading: "loading",
    }),
  },
  methods: {
    checkEditMode() {
      const currentPath = this.$route.path.toLowerCase();
      this.isEdit = !currentPath.includes("/view/");
      this.isAdd = !(
        currentPath.includes("/view/") || currentPath.includes("/edit/")
      );
    },
    ...mapActions("employeeModule", [
      "getEmployeeListAction",
      "getEmployeeByIdAction",
      "updateEmployeeAction",
      "addEmployeeDocAction",
      "addEmployeeAction",
      "getEmployeeIdDocAction",
    ]),
    resetForm() {
      // this.employeeProfile = JSON.parse(JSON.stringify(this.initialEmployeeProfile));
      this.$router.push({ name: "employee-listing" });
      this.tabValidations = {
        personalInfo: false,
        employmentDetails: false,
        bankDetails: false,
      };
    },
    updateEmployeeProfile(employeeProfiles) {
      this.employeeProfile.firstName = employeeProfiles.firstName;
      this.employeeProfile.lastName = employeeProfiles.lastName;
      this.employeeProfile.email = employeeProfiles.email;
      this.employeeProfile.nic = employeeProfiles.nic;
      this.employeeProfile.phoneNumber = employeeProfiles.phoneNumber;
      this.employeeProfile.gender = employeeProfiles.gender;
      this.employeeProfile.dateOfBirth = employeeProfiles.dateOfBirth;
      this.employeeProfile.state = employeeProfiles.state;
      this.employeeProfile.address = employeeProfiles.address;
      this.employeeProfile.additionalFields = employeeProfiles.additionalFields;
    },
    updateEmployement(employmentDetail) {
      this.employeeProfile.employmentStatus = employmentDetail.employmentStatus;
      this.employeeProfile.departmentId = employmentDetail.departmentId;
      this.employeeProfile.designationId = employmentDetail.designationId;
      this.employeeProfile.salary = employmentDetail.salary;
      this.employeeProfile.hireDate = employmentDetail.hireDate;
    },
    updateBank(bankDetails) {
      this.employeeProfile.bankName = bankDetails.bankName;
      this.employeeProfile.swiftCode = bankDetails.swiftCode;
      this.employeeProfile.branch = bankDetails.branch;
      this.employeeProfile.accountNumber = bankDetails.accountNumber;
    },

    async validateProfile() {
      // Access the child component and trigger its validation
      const isValid = await this.$refs.employeeProfileInfo.submitProfileForm();
      this.tabValidations.personalInfo = isValid;
      this.tabIndex = isValid ? this.tabIndex + 1 : this.tabIndex;
    },
    async validateDetails() {
      // Access the child component and trigger its validation
      const isValid = await this.$refs.employeeDetails.submitDetailsForm();
      this.tabValidations.employmentDetails = isValid;
      this.tabIndex = isValid ? this.tabIndex + 1 : this.tabIndex;
    },

    async validateBankDetails() {
      const personalInfoValid =
        await this.$refs.employeeProfileInfo.submitProfileForm();
      const employmentDetailsValid =
        await this.$refs.employeeDetails.submitDetailsForm();

      if (!personalInfoValid || !employmentDetailsValid) {
        let message = "Please complete the following sections:";
        if (!personalInfoValid) message += "\n- Personal Information";
        if (!employmentDetailsValid) message += "\n- Employment Details";

        customSwal(message, "Validation Error", "error");
        return;
      }

      const isValid =
        await this.$refs.employeeBankDetails.submitBankDetailsForm();
      if (isValid) {
        this.saveEmployee();
      } else {
        customSwal(
          "Please complete the Bank Details section.",
          "Validation Error",
          "error"
        );
      }
    },

    calculateAge(dob) {
      const birthDate = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();
      if (
        monthDifference < 0 ||
        (monthDifference === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      return age;
    },
    saveEmployee() {
  const age = this.calculateAge(this.employeeProfile.dateOfBirth);
  if (age < 18) {
    Swal.fire({
      title: "Warning",
      text: "Employee must be at least 18 years old.",
      icon: "warning",
    });
    return;
  }

  if (this.id === undefined) {
    console.log(this.employeeProfile, "PROFILE");

    this.addEmployeeAction(this.employeeProfile)
      .then((result) => {
        if (result.success) {
          Swal.fire({
            title: "Success",
            text: "Employee has been added successfully!",
            icon: "success",
          });
          
          this.$router.push({ name: 'employee-listing' });
          this.getEmployeeListAction();

          this.employeenewdocuments.forEach((document) => {
            let docForm = new FormData();
            docForm.append("DocumentType", document.documentType);
            docForm.append("DocumentName", document.documentName);
            if (document.issueDate) docForm.append("IssueDate", document.issueDate);
            if (document.expiryDate) docForm.append("ExpiryDate", document.expiryDate);
            docForm.append("Status", document.status);
            docForm.append("Notes", document.notes);
            docForm.append("EmployeeId", result.result.id);
            docForm.append("File", document.File);

            this.addEmployeeDocAction(docForm)
              .then(() => {
                console.log("Document added successfully.");
              })
              .catch((error) => {
                console.error(error);
                Swal.fire({
                  title: "Error",
                  text: "Failed to add document.",
                  icon: "error",
                });
                this.getEmployeeListAction();
              });
          });

        } else {
          Swal.fire({
            title: "Error",
            text: "Failed to add employee.",
            icon: "error",
          });
          this.getEmployeeListAction();
        }
      })
      .catch((error) => {
        this.error(error.response.data);
        this.loading = false;
        this.getEmployeeListAction();
      });
  } else {
    this.updateEmployeeAction(this.employeeProfile)
      .then((result) => {
        if (result.success) {
          Swal.fire({
            title: "Success",
            text: "Employee has been updated successfully!",
            icon: "success",
          });
          this.getEmployeeListAction();
        } else {
          Swal.fire({
            title: "Error",
            text: "Failed to update employee.",
            icon: "error",
          });
          this.getEmployeeListAction();
        }
      })
      .catch((error) => {
        console.error(error);
        this.error(error.response.data);
        this.loading = false;
        this.getEmployeeListAction();
      });
  }
},

error(data) {
      this.$swal("Error!", this.getErrorString(data) || "Failed!", "error");
    },

    getErrorString(data) {
      let msg = "";
      if (data.errors) {
        for (let prop in data.errors) {
          msg += `<p>${prop.replace("$.", "")}: ${data.errors[prop].toString().replace("$.", "")}</p>`;
        }
      } else if (data.message) {
        msg += `<p>${data.message}</p>`;
      }
      return msg + "</div>";
    },
  },
  async mounted() {
    this.checkEditMode();
    if (this.id != undefined) {
      await this.getEmployeeByIdAction(this.id).then(() => {
        this.employeeProfile = this.employeeDetail;
      });

      await this.getEmployeeListAction().then(
        () =>
          (this.managerList = this.managerData.filter(
            (v, i) => v.id != this.id
          ))
      );
      await this.getEmployeeIdDocAction(this.id);
    } else {
      await this.getEmployeeListAction().then(
        () => (this.managerList = this.managerData)
      );
    }
    this.employeeProfile.isEdit = this.isEdit;
    //check if user is an admin
    if (IsAdmin()) {
      this.employeeProfile.isEdit = true;
    }
  },
  setup(props) {
    return {
      IsAdmin,
      HasPermission,
    };
  },
};
</script>
